import { Component, OnInit, ViewChild, Pipe, PipeTransform, Inject, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialog} from '@angular/material';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {UserService} from '../shared/user.service';
import {StatusMap} from './assignment.model';
import {FiltersService} from './filters.service';
import {ViewService} from '../shared/view.service';

@Pipe({name: 'status'})
export class StatusPipe implements PipeTransform {
    transform(value: string, clone: any): string {
        if( StatusMap.hasOwnProperty(value) ) {
            value = StatusMap[value];
            if( value == 'Published' && clone ) {
                value = 'Copy ' + value;
            }
        }
        return value;
    }
}
@Component({
    selector: 'assignment-list',
    templateUrl: 'assignment-list.component.html'
})
export class AssignmentsComponent implements OnDestroy{
    filterSubscription;
    heartbeatSubscription;
    title = 'All Assignments';
    service;
    subscription;
    user;
    selectedRows = [];
    canDelete = false;
    taxSlugs = [];

    @ViewChild('paginator') paginator;
    @ViewChild('table') table;

    constructor(
        private route: ActivatedRoute, 
        private assignmentSerivce: AssignmentsService, 
        private userService: UserService, 
        private api: ApiService,
        private fs: FiltersService,
        public dialog: MatDialog,
        private vs: ViewService
    ) {
        this.title = this.route.snapshot.data.title;
        this.service = assignmentSerivce;
        this.user = api.getProp('user');
        this.taxSlugs = Object.keys(api.getProp('taxonomies'));
        if( this.user.role == 'editor' || this.user.role == 'administrator' ) {
            this.canDelete = true;
        }
        this.filterSubscription = fs.filtersChange.subscribe(query => {
            if( this.paginator ) {
                this.paginator.firstPage();
            }
            if( this.route.snapshot.data.state == 'queue' ) {
                query = Object.assign({queue: true, user: this.user.id}, query);
            }
            if( this.route.snapshot.data.state == 'sentToEditor' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('sent_to_editor') || filter.value.includes('add_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'sent_to_editor|add_sent_to_editor', compare: '='});
                }
            }
            if( this.route.snapshot.data.state == 'assigned' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('assigned');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query.filters.push({key: 'status', value: 'assigned', compare: '='});
                }
            }
            this.assignmentSerivce.userQuery = 0;
            if( this.route.snapshot.queryParams.hasOwnProperty('user') ) {
                this.assignmentSerivce.userQuery = this.route.snapshot.queryParams.user;
            }
            this.assignmentSerivce.loadAssignments(query);
        });
        this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
            this.service.refresh();
        });
        this.assignmentSerivce.deleted.subscribe(data => {
            this.table.renderRows();
            this.selectedRows = [];
        });
    }
    ngOnInit() {
        this.subscription = this.route.queryParams.subscribe(query => {
            if( this.route.snapshot.data.state == 'queue' ) {
                query = Object.assign({queue: true, user: this.user.id}, query);
            }
            if( this.route.snapshot.data.state == 'sentToEditor' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('sent_to_editor') || filter.value.includes('add_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'sent_to_editor|add_sent_to_editor', compare: '='}]}, query);
                }
            }
            if( this.route.snapshot.data.state == 'assigned' ) {
                let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('assigned');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'assigned', compare: '='}]}, query);
                }
            }
            this.assignmentSerivce.userQuery = 0;
            if( query.hasOwnProperty('user') ) {
                this.assignmentSerivce.userQuery = query.user;
            }
            if( query.hasOwnProperty('view') ) {
                this.vs.setCurrentView(query.view);               
            } else {
                this.vs.setCurrentView(false);
            }         
        });
    }
    pageChange(event) {
        this.service.pageSize = event.pageSize;
        let query = Object.assign({page: (event.pageIndex + 1), per_page: event.pageSize}, this.route.snapshot.queryParams);
        if( this.route.snapshot.data.state == 'queue' ) {
            query = Object.assign({user: this.user.id, queue: true}, query);
        }
        if( this.route.snapshot.data.state == 'sentToEditor' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('sent_to_editor') || filter.value.includes('add_sent_to_editor');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
            if(!queryExists) {
                query = Object.assign({filters: [{key: 'status', value: 'sent_to_editor|add_sent_to_editor', compare: '='}]}, query);
            }
        }
        if( this.route.snapshot.data.state == 'assigned' ) {
            let queryExists = false;
                if(!!query.filters) {
                    queryExists = query.filters.filter(filter => {
                        let keyMatch = filter.key === 'status';
                        let valueMatch = filter.value.includes('assigned');
        
                        return keyMatch && valueMatch;
                    }).length > 0;
                }
                if(!queryExists) {
                    query = Object.assign({filters: [{key: 'status', value: 'assigned', compare: '='}]}, query);
                }
        }
        let filterQuery = this.fs.query;
        if( filterQuery.filters.length > 0 ) {
            query = Object.assign(query, filterQuery);
        }
        this.service.loadAssignments(query);
    }
    inSelectedRows(item) {
        return this.getItemIndex(item) !== -1;
    }
    getItemIndex(item) {
        return this.selectedRows.reduce((out, el, i) => {
            if( el.id === item.id ) {
                out = i;
            }
            return out;
        }, -1);
    }
    selectRowChange(event, item, go) {
        let index = this.getItemIndex(item);
        if( event.checked && index === -1 ) {
            this.selectedRows.push(item);
        }
        if( !event.checked && index !== -1 ) {
            this.selectedRows.splice(index, 1);
        }
        if( go && this.selectedRows.length > 0 ) {
            this.assignmentSerivce.delete(this.selectedRows);
        }
    }
    getQuizType(item) {
        if( item.childType !== 'quiz' ) {
            return '';
        }
        return item.quizType === 'personality' ? 'Personality' : 'Standard';
    }
    getTerms(item, slug) {
        if( !item.taxonomies[slug] ) {
            return '';
        }
        return item.taxonomies[slug].map(item => item.name).join(', ');
    }
    getTaxTitle(item) {
        var taxes = Object.keys(item.taxonomies);
        var title = [];
        for(var i = 0; i < taxes.length; i++) {
            const tax = taxes[i];
            title.push(this.api['taxonomies'][tax].name);
        }
        return title.join(', ');
    }
    ngOnDestroy() {
        if( this.subscription ) {
            this.subscription.unsubscribe();
        }
        if( this.filterSubscription ) {
            this.filterSubscription.unsubscribe();
        }
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/assignments/assignment-list.component.ts